import { useRef, useState } from 'react';
import { chileTerritory } from '../data/chileTerritory';

function Projects({
  projects,
  activeProjectId,
  setActiveProjectId,
  newProject,
  setNewProject,
  guardarProyecto,
  eliminarProyecto,
  actualizarProyecto
}) {
  const [showForm, setShowForm] = useState(false);
  const [editingProjectId, setEditingProjectId] = useState(null);
  const formRef = useRef(null);

  const limpiarFormulario = () => {
    setEditingProjectId(null);
    setShowForm(false);
    setNewProject({
      nombre: '', cliente: '', tipo: '', region: '', regionCodigo: '',
      estado: '', descripcion: '', clienteEmail: '', clientePassword: ''
    });
  };

  const nuevoProyecto = () => {
    setEditingProjectId(null);
    setNewProject({
      nombre: '', cliente: '', tipo: '', region: '', regionCodigo: '',
      estado: '', descripcion: '', clienteEmail: '', clientePassword: ''
    });
    setShowForm(true);
    setTimeout(() => formRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' }), 120);
  };

  const editarProyecto = (project) => {
    setEditingProjectId(project.id);
    setNewProject({
      nombre: project.nombre || '',
      cliente: project.cliente || '',
      tipo: project.tipo || '',
      region: project.region || '',
      regionCodigo: project.regionCodigo || '',
      estado: project.estado || '',
      descripcion: project.descripcion || '',
      clienteEmail: '',
      clientePassword: ''
    });
    setShowForm(true);
    setTimeout(() => formRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' }), 120);
  };

  const onRegionChange = (e) => {
    const nombreRegion = e.target.value;
    const item = chileTerritory.find((r) => r.region === nombreRegion);
    setNewProject({
      ...newProject,
      region: nombreRegion,
      regionCodigo: item ? item.codigoGeoJSON : ''
    });
  };

  const guardar = async () => {
    if (editingProjectId && actualizarProyecto) {
      await actualizarProyecto(editingProjectId);
    } else {
      await guardarProyecto();
    }
    limpiarFormulario();
  };

  return (
    <div>
      <div style={styles.header}>
        <div>
          <h1 style={styles.title}>Gestión de Territorios</h1>
          <p style={styles.subtitle}>Administra proyectos, territorios y unidades de análisis.</p>
        </div>
        <button style={styles.primaryButton} onClick={nuevoProyecto}>+ Nuevo Proyecto</button>
      </div>

      <div style={styles.card}>
        <h2>Proyectos registrados</h2>
        {projects.length === 0 && <p style={styles.empty}>No hay proyectos registrados.</p>}
        <div style={styles.projectGrid}>
          {projects.map((project) => {
            const isActive = project.id === activeProjectId;
            return (
              <div key={project.id} style={{ ...styles.projectCard, border: isActive ? '2px solid #1fa97a' : '1px solid #e4e7ec' }}>
                <div style={styles.projectTop}>
                  <div>
                    <h3 style={styles.projectName}>{project.nombre || 'Proyecto sin nombre'}</h3>
                    <p style={styles.projectMeta}>{project.cliente || 'Sin cliente'} · {project.region || 'Sin región'}</p>
                    {project.clienteEmail && (
                      <p style={{ color: '#0993b5', fontSize: '12px', marginTop: '4px' }}>
                        👤 {project.clienteEmail}
                      </p>
                    )}
                  </div>
                  <span style={styles.statusBadge}>{project.estado || 'Sin estado'}</span>
                </div>
                <p style={styles.description}>{project.descripcion || 'Sin descripción registrada.'}</p>
                <div style={styles.actions}>
                  <button style={styles.viewButton} onClick={() => setActiveProjectId(project.id)}>Ver</button>
                  <button style={styles.editButton} onClick={() => editarProyecto(project)}>Editar</button>
                  <button style={styles.deleteButton} onClick={() => eliminarProyecto(project.id)}>Eliminar</button>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {showForm && (
        <div ref={formRef}>
          <div style={styles.formCard}>
            <div style={styles.formHeader}>
              <h2>{editingProjectId ? 'Editar Proyecto' : 'Crear Nuevo Proyecto'}</h2>
              <button style={styles.closeButton} onClick={limpiarFormulario}>Cerrar</button>
            </div>

            <div style={styles.formGrid}>
              <input style={styles.input} placeholder="Nombre del proyecto" value={newProject.nombre}
                onChange={(e) => setNewProject({ ...newProject, nombre: e.target.value })} />
              <input style={styles.input} placeholder="Cliente" value={newProject.cliente}
                onChange={(e) => setNewProject({ ...newProject, cliente: e.target.value })} />
              <input style={styles.input} placeholder="Tipo de proyecto" value={newProject.tipo}
                onChange={(e) => setNewProject({ ...newProject, tipo: e.target.value })} />
              <select style={styles.input} value={newProject.region || ''} onChange={onRegionChange}>
                <option value="">Región del proyecto</option>
                {chileTerritory.map((r) => (
                  <option key={r.region} value={r.region}>{r.region}</option>
                ))}
              </select>
              <select style={styles.input} value={newProject.estado}
                onChange={(e) => setNewProject({ ...newProject, estado: e.target.value })}>
                <option value="">Estado del proyecto</option>
                <option value="Diagnóstico inicial">Diagnóstico inicial</option>
                <option value="En monitoreo">En monitoreo</option>
                <option value="Riesgo territorial">Riesgo territorial</option>
                <option value="En gestión">En gestión</option>
                <option value="Cerrado">Cerrado</option>
              </select>
            </div>

            <textarea style={styles.textarea} placeholder="Descripción del proyecto"
              value={newProject.descripcion}
              onChange={(e) => setNewProject({ ...newProject, descripcion: e.target.value })} />

            {!editingProjectId && (
              <div style={styles.clienteBox}>
                <div style={styles.clienteBoxLabel}>ACCESO CLIENTE — correo y contraseña para este proyecto</div>
                <div style={styles.formGrid}>
                  <input style={styles.input} placeholder="Correo del cliente (ej: cliente@empresa.cl)"
                    value={newProject.clienteEmail || ''}
                    onChange={(e) => setNewProject({ ...newProject, clienteEmail: e.target.value })} />
                  <input style={styles.input} type="password" placeholder="Contraseña del cliente"
                    value={newProject.clientePassword || ''}
                    onChange={(e) => setNewProject({ ...newProject, clientePassword: e.target.value })} />
                  <input style={styles.input} type="password" placeholder="Repetir contraseña"
                    value={newProject.clientePasswordConfirm || ''}
                    onChange={(e) => setNewProject({ ...newProject, clientePasswordConfirm: e.target.value })} />
                </div>
              </div>
            )}

            <button style={styles.saveButton} onClick={guardar}>
              {editingProjectId ? 'Guardar cambios' : 'Guardar proyecto'}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

const styles = {
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '28px' },
  title: { margin: 0, fontSize: '36px', color: '#071a2f' },
  subtitle: { color: '#667085' },
  primaryButton: { background: 'linear-gradient(135deg,#1fa97a,#0993b5)', color: 'white', border: 'none', padding: '14px 22px', borderRadius: '14px', fontWeight: 'bold', cursor: 'pointer' },
  card: { background: 'white', padding: '30px', borderRadius: '20px', boxShadow: '0 12px 35px rgba(7,26,47,0.08)', marginBottom: '28px' },
  projectGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(280px,1fr))', gap: '18px' },
  projectCard: { padding: '22px', borderRadius: '18px', background: '#ffffff', boxShadow: '0 8px 24px rgba(7,26,47,0.06)' },
  projectTop: { display: 'flex', justifyContent: 'space-between', gap: '14px' },
  projectName: { margin: 0, color: '#071a2f' },
  projectMeta: { color: '#667085', fontSize: '14px' },
  statusBadge: { background: '#eef4ff', color: '#092395', padding: '6px 10px', borderRadius: '999px', fontSize: '12px', fontWeight: 'bold', height: 'fit-content' },
  description: { color: '#667085', lineHeight: '1.5' },
  actions: { display: 'flex', gap: '10px', marginTop: '18px' },
  viewButton: { background: '#071a2f', color: 'white', border: 'none', padding: '10px 14px', borderRadius: '10px', cursor: 'pointer' },
  editButton: { background: '#1fa97a', color: 'white', border: 'none', padding: '10px 14px', borderRadius: '10px', cursor: 'pointer' },
  deleteButton: { background: '#dc2626', color: 'white', border: 'none', padding: '10px 14px', borderRadius: '10px', cursor: 'pointer' },
  formCard: { background: 'white', padding: '30px', borderRadius: '20px', boxShadow: '0 12px 35px rgba(7,26,47,0.08)' },
  formHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  closeButton: { background: '#f0f2f5', border: 'none', padding: '10px 14px', borderRadius: '10px', cursor: 'pointer' },
  formGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(220px,1fr))', gap: '14px', marginTop: '20px' },
  input: { padding: '14px', borderRadius: '12px', border: '1px solid #d0d5dd' },
  textarea: { width: '100%', minHeight: '120px', padding: '14px', borderRadius: '12px', border: '1px solid #d0d5dd', marginTop: '16px', marginBottom: '18px', boxSizing: 'border-box' },
  saveButton: { background: 'linear-gradient(135deg,#1fa97a,#0993b5)', color: 'white', border: 'none', padding: '14px 22px', borderRadius: '14px', fontWeight: 'bold', cursor: 'pointer' },
  clienteBox: { background: '#f0f9ff', border: '1px solid #bae6fd', borderRadius: '12px', padding: '16px', marginBottom: '18px' },
  clienteBoxLabel: { color: '#075985', fontSize: '12px', fontWeight: '700', marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.5px' },
  empty: { color: '#667085' }
};

export default Projects;